import type { ErrorComponentProps } from '@tanstack/react-router';
import { ApiRequestError } from '../../shared/api';

/**
 * §19 ТЗ. Аварийный экран роутера по умолчанию — английское «Something went
 * wrong!» с кнопкой «Show Error»: тексты для человека должны быть русскими, а
 * из мёртвой страницы должен быть выход. Идентификатор запроса показывается,
 * когда сервер его вернул: с ним обращение к администратору осмысленно.
 */
export function ErrorPage({ error, reset }: ErrorComponentProps) {
  const correlationId = error instanceof ApiRequestError ? error.payload.correlationId : undefined;

  return (
    <main className="centered">
      <section className="card">
        <h1>Не удалось открыть раздел</h1>
        <p className="muted">
          Повторите попытку. Если ошибка повторяется, сообщите администратору системы.
        </p>
        {correlationId && <p className="muted">Идентификатор запроса: {correlationId}</p>}
        <div className="form__actions">
          <button type="button" onClick={reset}>
            Повторить
          </button>
          <a className="btn-primary" href="/login">
            На страницу входа
          </a>
        </div>
      </section>
    </main>
  );
}
